import {ZodTypeAny} from 'zod';
import {AgentBase, AgentContext, AgentScratchpadContext, Tool} from '../../copilot.types';
import {OpenAIModelConfig} from '../../openAI/openAI.models';

interface AgentBaseCreatorParams<T extends ZodTypeAny> {
  name: string;
  role: string;
  instructions?: string;
  tools?: Tool<ZodTypeAny>[];
  model: OpenAIModelConfig;
  classificationModel?: OpenAIModelConfig;
  responseSchema: T;
  contexts?: AgentContext[];
  scratchpad?: (chatId: string) => AgentScratchpadContext;
}

export default function agentBase<T extends ZodTypeAny>({
  name,
  role,
  instructions,
  tools = [],
  model,
  classificationModel,
  responseSchema,
  contexts = [],
  scratchpad,
}: AgentBaseCreatorParams<T>): AgentBase<T> {
  const toolNames = tools?.map((tool) => tool.name) ?? [];
  _verifyNoDuplicates(toolNames);

  return {
    name,
    role,
    instructions: instructions ?? '',
    tools,
    responseSchema,
    model,
    classificationModel,
    contexts,
    scratchpad,
  };
}

function _verifyNoDuplicates(toolNames: string[]): void {
  const duplicates = toolNames.filter((name, index) => toolNames.indexOf(name) !== index);

  if (duplicates.length > 0) {
    throw new Error(`Duplicate tool names found: ${duplicates.join(', ')}`);
  }
}
